import React, { use, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import Header from '../components/Header';
import Leftmenu from '../components/Leftmenu';
import Rightmenu from '../components/Rightmenu';
import { useOutletContext } from "react-router-dom";
import { ToastContainer, toast, Bounce } from 'react-toastify';

function UpdateProfile() {
  const { user, token } = useOutletContext();
  const { type } = useParams();
  const [Personal, setPersonal] = useState({});
  const [personalform, setPersonalform] = useState({});
  const [academic, setAcademic] = useState({});
  const [academicerrors, setAcademicerrors] = useState({});
  const [hasPhd, setHasPhd] = useState(false);
  const [hasPostgrad, sethasPostgrad] = useState(false);
  const [ugCourses, setUgCourses] = useState([]);
  const [pgCourses, setPgCourses] = useState([]);
  const [professional, setProfessional] = useState([{ organisation: "", designation: "", payscale: "", start_date: "", end_date: "", is_current: "" }]);
  const [professional1, setprofessional1] = useState({});
    const [loader, setLoader] = useState(false);
 const success = () => toast.success('Profile Updated!', {
position: "top-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: false,
pauseOnHover: true,
draggable: true,
progress: undefined,
theme: "colored",
transition: Bounce,
});
  console.log(type);
  const [step, setStep] = useState(0);

 useEffect(() => {
      if (type=="basic") {
      setStep(1); 

    } else if(type=="personal") {
      setStep(2);
      fetch('/api/get-personal-info', {
        method: 'POST',
        headers: {
          Authorization: `bearer ${token}`,
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
      
      }).then((response) => response.json())
      .then((data) => {
        setPersonal(data.data);
        const {profile_picture, ...rest} = data.data;
        rest.dob = data.data.date_of_birth;
        rest.about = data.data.bio;
        console.log("Rest", rest)
        setPersonalform(rest);
      }).catch((error) => {

      }).finally(() => {
        
      });

      
    } else if(type=="academic") {
      setStep(3);   
      fetch('/api/get-academic-info', {
        method: 'POST',
        headers: {
          Authorization: `bearer ${token}`,
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
      
      }).then((response) => response.json())
      .then((data) => {
        setAcademic(data.data);
      }).catch((error) => {

      }).finally(() => {
        setHasPhd(academic.has_phd);
        sethasPostgrad(academic.post_graduation);
      })
        const getCourses = () => {
          fetch("https://admin.tiut.ac.in/api/v1/programs")
            .then((response) => response.json())
            .then((data) => {
              const programList = Array.isArray(data) ? data : data?.data || [];
              const ugList = programList.filter(
                (p) => String(p.program_type || p.course_type).toUpperCase() === "UG"
              );
              const pgList = programList.filter(
                (p) => String(p.program_type || p.course_type).toUpperCase() === "PG"
              );

              if (ugList.length > 0) setUgCourses(ugList);
              if (pgList.length > 0) setPgCourses(pgList);

              if (ugList.length === 0 || pgList.length === 0) {
                fetchLocalCourses(ugList.length > 0, pgList.length > 0);
              }
            })
            .catch((error) => {
              console.error("Error fetching programs from admin.tiut.ac.in:", error);
              fetchLocalCourses(false, false);
            });
        };

        const fetchLocalCourses = (hasUgAlready = false, hasPgAlready = false) => {
          fetch("/api/courses", {
            method: "POST",
            headers: {
              Authorization: `bearer ${token}`,
            },
          })
            .then((response) => response.json())
            .then((data) => {
              if (!hasUgAlready && data.ug_courses && data.ug_courses.length > 0) {
                setUgCourses(data.ug_courses);
              }
              if (!hasPgAlready && data.pg_courses && data.pg_courses.length > 0) {
                setPgCourses(data.pg_courses);
              }
            })
            .catch((err) => {
              console.error("Error fetching local courses fallback:", err);
            });
        };
    getCourses();
    } else if(type=="professional") {
      setStep(4);
      fetch('/api/get-professional-info', {
        method: 'POST',
        headers: {
          Authorization: `bearer ${token}`,
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
      }).then((response) => response.json())
      .then((data) => {
        if (data && data.data) {
          const exp = (data.data.experience && data.data.experience.length > 0)
            ? data.data.experience
            : [{ organisation: "", designation: "", pay_scale: "", start_date: "", end_date: "", is_current: "" }];
          setProfessional(exp);
          setprofessional1(data.data);
          setProfessionalform({
            employability_status: data.data.employability_status || "",
            work_status: data.data.work_status || ""
          });
        }
      }).catch((error) => {
        console.error("Error fetching professional info:", error);
      }).finally(() => {
        
      });
  }else{
    setStep(0);
  }

 },[]);
useEffect(()=>{
console.log("running",Personal);
},[Personal])



 const handlePersonal = (e) => {
        setPersonalform({ ...personalform, [e.target.name]: e.target.value });
    };
     const handleSubmitPersonal = (e) => {
        e.preventDefault();

        setLoader(true);

       

        const personaldata = new FormData();

        // Append text fields
        for (const key in personalform) {
            if (key !== "profile_picture") {
                personaldata.append(key, personalform[key]);
            }
        }

        // Append file
        if (personalform.profile_picture) {
            personaldata.append(
                "profile_picture",
                personalform.profile_picture
            );
        }

        fetch(`/api/update-personal-information`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: personaldata,
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.errors) {
                    setLoader(false);
                    setPersonalerrors(data.errors);
                }
                if (data.message) {
                    
                    setLoader(false);
                    success();
                    

                }

                setLoader(false);
            })
            .catch((error) => {
                console.error("Error:", error);
                setLoader(false);
            });

        return false;
    };


//Handle Professional Information Logic
    const [professionalform, setProfessionalform] = useState({
        employability_status: "",
        work_status: ""
    });
  
    const addRow = () => {
        setProfessional([...professional, { organisation: "", designation: "", pay_scale: "", start_date: "", end_date: "", is_current: "" }]);
    };

    const removeRow = (index) => {
        setProfessional(professional.filter((_, i) => i !== index));
    };
    const [professionalerrors, setProfessionalerrors] = useState({});
    const handleProfessionalChange = (e) => {
        setProfessionalform({
            ...professionalform,
            [e.target.name]: e.target.value
        });
        if (professionalerrors[e.target.name] || professionalerrors[`professionalinfo.${e.target.name}`]) {
            setProfessionalerrors(prev => {
                const updated = { ...prev };
                delete updated[e.target.name];
                delete updated[`professionalinfo.${e.target.name}`];
                return updated;
            });
        }
    };
    const handleProfessionalWorkChange = (index, field, value) => {
        const updated = [...professional];
        updated[index] = {
            ...updated[index],
            [field]: value
        };
        if (field === 'is_current' && (value === "1" || value === 1)) {
            updated[index].end_date = "";
        }
        setProfessional(updated);
    };

    const handleSubmitProfessional = (e) => {
        e.preventDefault();
        setLoader(true);
        setProfessionalerrors({});

        let final = {
            professionalinfo: professionalform,
            workExperience: professional
        };

        fetch('/api/professional-update', {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify(final),
        })
        .then((response) => response.json())
        .then((data) => {
            setLoader(false);
            if (data.errors) {
                setProfessionalerrors(data.errors);
            } else if (data.data && data.message) {
                success();
                if (data.data.professionalinfo) {
                    setProfessionalform({
                        employability_status: data.data.professionalinfo.employability_status || "",
                        work_status: data.data.professionalinfo.work_status || ""
                    });
                    setprofessional1(data.data.professionalinfo);
                }
                if (data.data.workExperience) {
                    setProfessional(data.data.workExperience.length > 0 ? data.data.workExperience : [
                        { organisation: "", designation: "", pay_scale: "", start_date: "", end_date: "", is_current: "" }
                    ]);
                }
            } else if (data.error) {
                toast.error(data.error);
            }
        })
        .catch((error) => {
            console.error("Error:", error);
            setLoader(false);
            toast.error("An error occurred while saving professional info.");
        });
    };

  return (
    <div>
        {loader && <div className="preloader"></div>}
         <ToastContainer
         position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Bounce}

         />
        <Header />
        <Leftmenu />
        <Rightmenu />
             {step == 1 && (
                <div
                    className="main-content bg-lightblue theme-dark-bg right-chat-active"
                    style={{ minHeight: "100vh" }}
                >
                    <div className="middle-sidebar-bottom">
                        <div className="middle-sidebar-left">
                            <div className="middle-wrap">
                                <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
                                    <div className="card-body p-4 w-100 bg-current border-0 d-flex rounded-3">
                                        <Link to="/settings" className="d-flex align-items-center">
                                            <i className="ti-arrow-left font-sm text-white" />
                                        </Link>
                                        <h4 className="font-xs text-white fw-600 ms-4 mb-0 mt-2">
                                            Personal Information
                                        </h4>
                                    </div>
                                    <div className="card-body p-lg-5 p-4 w-100 border-0">
                                        <form >
                                            <div className="row">
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Name
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="name"
                                                            className="form-control"
                                                            disabled
                                                            value={user.name}
                                                           
                                                            required
                                                        />
                                                       
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Email
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="email"
                                                            name="email"
                                                            className="form-control"
                                                            disabled
                                                            value={user.email}
                                                            required
                                                        />
                                                       
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Phone
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="tel"
                                                            name="phone"
                                                            className="form-control"
                                                            value={user.phone}
                                                            disabled
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Role
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="phone"
                                                            className="form-control"
                                                            value={user.role}
                                                            disabled
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Approved Status
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="phone"
                                                            className="form-control"
                                                            value={user.status}
                                                            disabled
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                
                                          
                                            </div>
                                  
                                          
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
             {step == 2 && (
                <div
                    className="main-content bg-lightblue theme-dark-bg right-chat-active"
                    style={{ minHeight: "100vh" }}
                >
                    <div className="middle-sidebar-bottom">
                        <div className="middle-sidebar-left">
                            <div className="middle-wrap">
                                <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
                                    <div className="card-body p-4 w-100 bg-current border-0 d-flex rounded-3">
                                        <Link to="/settings" className="d-flex align-items-center">
                                            <i className="ti-arrow-left font-sm text-white" />
                                        </Link>
                                        <h4 className="font-xs text-white fw-600 ms-4 mb-0 mt-2">
                                            Personal Information
                                        </h4>
                                    </div>
                                    <div className="card-body p-lg-5 p-4 w-100 border-0">
                                        <form onSubmit={handleSubmitPersonal}>
                                            <div className="row">
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Bio
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                     <textarea
                                                        name="about"
                                                        className="form-control"
                                                        value={personalform?.about || ""}
                                                        onChange={handlePersonal}
                                                        required
                                                        
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Date of Birth
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="date"
                                                            name="dob"
                                                            className="form-control"
                                                            value={personalform?.dob || ""}
                                                            onChange={handlePersonal}
                                                            required
                                                            
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Gender
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <select
                                                            name="gender"
                                                            className="form-select"
                                                            value={personalform?.gender || ""}
                                                            onChange={handlePersonal}
                                                            required
                                                            
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="male">Male</option>
                                                            <option value="female">Female</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Marital Status
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <select
                                                            name="marital_status"
                                                            className="form-select"
                                                            value={personalform?.marital_status}
                                                            onChange={handlePersonal}
                                                            required
                                                            
                                                        >
                                                            <option value="single">Single</option>
                                                            <option value="married">Married</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Emergency Contact
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="tel"
                                                            name="emergency_contact"
                                                            className="form-control"
                                                            value={personalform?.emergency_contact}
                                                            onChange={handlePersonal}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Whatsapp
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="tel"
                                                            name="whatsapp"
                                                            className="form-control"
                                                            value={personalform?.whatsapp}
                                                            onChange={handlePersonal}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Present Address
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="present_address"
                                                            className="form-control"
                                                            value={personalform?.present_address}
                                                            onChange={handlePersonal}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Permanent Address
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="permanent_address"
                                                            className="form-control"
                                                            onChange={handlePersonal}
                                                            value={personalform?.permanent_address}
                                                            
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Profile Picture
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="file"
                                                            name="profile_picture"
                                                            className="form-control"
                                                             onChange={(e) =>
                                                                setPersonalform(
                                                                    {
                                                                        ...personalform,
                                                                        profile_picture:
                                                                            e
                                                                                .target
                                                                                .files[0],
                                                                    }
                                                                )
                                                            }
                                                            
                                                        />
                                                        <br />
                                                        <a href={Personal?.profile_picture} target="_blank" className='btn bg-current text-white my-2'>
                                                            View
                                                        </a>
                                                    </div>
                                                </div>

                                                <div className="col-lg-12">
                                                    <div className="form-group">
                                                        <button
                                                            type="submit"
                                                            className="btn btn-block bg-current text-white"
                                                        >
                                                            Update
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                                </form>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
               
            )}
             {step == 3 && (
                <div
                    className="main-content bg-lightblue theme-dark-bg right-chat-active"
                    style={{ minHeight: "100vh" }}
                >
                    <div className="middle-sidebar-bottom">
                        <div className="middle-sidebar-left">
                            <div className="middle-wrap">
                                <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
                                    <div className="card-body p-4 w-100 bg-current border-0 d-flex rounded-3">
                                        <Link to="/settings" className="d-flex align-items-center">
                                            <i className="ti-arrow-left font-sm text-white" />
                                        </Link>
                                        <h4 className="font-xs text-white fw-600 ms-4 mb-0 mt-2">
                                            Academic Information
                                        </h4>
                                    </div>
                                    <div className="card-body p-lg-5 p-4 w-100 border-0">
                                        <form >
                                            <div className="row">
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Tenth Institution
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="tenth_institution"
                                                            className="form-control"
                                                            disabled
                                                            value={academic.tenth_institution}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Tenth Board
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="tenth_board"
                                                            className="form-control"
                                                            disabled
                                                            value={academic.tenth_board}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Tenth Year
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="tenth_year"
                                                            className="form-control"
                                                            disabled
                                                            value={academic.tenth_year}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Tenth Percentage
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="tenth_percentage"
                                                            className="form-control"
                                                            disabled
                                                            value={academic.tenth_percentage}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Tenth Certificate
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <br />
                                                        <a href={academic.tenth_certificate} target="_blank" className="btn bg-current text-white" >
                                                            View
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Twelth Institution
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="twelth_institution"
                                                            className="form-control"
                                                            disabled
                                                            value={academic.twelth_institution}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Twelth Board
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="twelth_board"
                                                            className="form-control"
                                                            disabled
                                                            value={academic.twelth_board}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Twelth Year
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="twelth_year"
                                                            className="form-control"
                                                            disabled
                                                            value={academic.twelth_year}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Twelth Percentage
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="twelth_percentage"
                                                            className="form-control"
                                                            disabled
                                                            value={academic.twelth_percentage}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Twelth Certificate
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <br />
                                                        <a href={academic.twelth_certificate} target="_blank" className="btn bg-current text-white">
                                                            View
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Graduation Institution
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="graduation_institution"
                                                            className="form-control"
                                                            disabled
                                                            value={academic.graduation_institution}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Graduation Degree
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="graduation_degree"
                                                            className="form-control"
                                                            disabled
                                                            value={academic.graduation_degree}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Graduation Start Year
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="graduation_start_year"
                                                            className="form-control"
                                                            disabled
                                                            value={academic.graduation_start_year}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Graduation End Year
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="graduation_end_year"
                                                            className="form-control"
                                                            disabled
                                                            value={academic.graduation_end_year}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Graduation Percentage
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="graduation_percentage"
                                                            className="form-control"
                                                            disabled
                                                            value={academic.graduation_percentage}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Graduation Certificate
                                                              <span className="text-danger">*</span>
                                                        </label>
                                                        <br />
                                                        <a href={academic.graduation_certificate} target="_blank" className="btn bg-current text-white">
                                                            View
                                                        </a>
                                                    </div>
                                                </div>
                                               <h3 className="fw-600 font-xss mb-3">
                                                    Post Graduation Information
                                                </h3>
                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Is Post
                                                            Graduataed/Persuing{" "}
                                                           <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <select
                                                            name="post_graduation"
                                                            className="form-select"
                                                            value={academic?.post_graduation}
                                                            disabled
                                                        >
                                                            <option value="">
                                                                Select
                                                            </option>
                                                            <option value="1">
                                                                Yes
                                                            </option>
                                                            <option value="0">
                                                                No
                                                            </option>
                                                        </select>
                                                       
                                                    </div>
                                                </div>
                                                <div
                                                    className={
                                                        hasPostgrad == true
                                                            ? "row"
                                                            : "d-none"
                                                    }
                                                >
                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                Post Graduation From SNU?{" "}
                                                                <span className="text-danger">
                                                                    *
                                                                </span>
                                                            </label>
                                                           <select 
                                                                name="is_snu_pg"
                                                                className="form-select"
                                                                value={academic?.is_snu_pg}
                                                                disabled
                                                            >
                                                                <option value="">
                                                                    Select
                                                                </option>
                                                                <option value="1">
                                                                    Yes
                                                                </option>
                                                                <option value="0">
                                                                    No
                                                                </option>
                                                            </select>
                                                            
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                Post Graduation
                                                                Institution
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="post_graduation_institution"
                                                                className="form-control"
                                                                disabled
                                                               
                                                                value={
                                                                    academic.post_graduation_institution
                                                                }
                                                            />
                                                            
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                Post Graduation
                                                                Degree
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="post_graduation_degree"
                                                                className="form-control"
                                                               value={
                                                                    academic.post_graduation_degree}
                                                                    disabled
                                                            />
                                                            
                                                        </div>
                                                    </div>
                                                    {
                                                        academic.is_snu_pg == 1 && (
                                                            <div className="col-lg-6 mb-3">
                                                                <div className="form-group">
                                                                    <label className="mont-font fw-600 font-xsss">
                                                                        Post Graduation Course
                                                                    </label>
                                                                    <select 
                                                                        name="course_id_pg"
                                                                        className="form-select"
                                                                        
                                                                        value={
                                                                            academic.course_id_pg
                                                                        }
                                                                        disabled
                                                                    >
                                                                        <option value="0">
                                                                            Select
                                                                        </option>
                                                                        {
                                                                            pgCourses.map((course, index) => (
                                                                                <option key={course.id || index} value={course.id}>
                                                                                    {course.course_name || course.name}
                                                                                </option>
                                                                            ))
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                            {
                                                        academic.is_snu_pg == 0 && (
                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                Post Graduation
                                                                Course
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="post_graduation_course"
                                                                className="form-control"
                                                                value={academic?.post_graduation_course}
                                                            />
                                                        
                                                        </div>
                                                    </div>)}
                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                Post Graduation
                                                                Start Year
                                                            </label>
                                                            <input
                                                                type="number"
                                                                name="post_graduation_start_year"
                                                                className="form-control"
                                                                value={academic?.post_graduation_start_year}
                                                                disabled
                                                            />
                                                         
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                Post Graduation
                                                                End Year
                                                            </label>
                                                            <input
                                                                type="number"
                                                                name="post_graduation_end_year"
                                                                className="form-control"
                                                                value={academic.post_graduation_end_year}
                                                                disabled
                                                            />
                                                           
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                Post Graduation
                                                                Percentage
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="post_graduation_percentage"
                                                                className="form-control"
                                                                value={academic.post_graduation_percentage}
                                                                disabled
                                                            />
                                                          
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                Post Graduation
                                                                Certificate{" "}
                                                                <span className="text-danger">
                                                                    (jpg,png,pdf)
                                                                </span>
                                                            </label>
                                                            <br />
                                                            <a href={academic?.post_graduation_certificate} target="_blank" className='btn bg-current text-white' >View Certificate</a>
                                                          
                                                        </div>
                                                    </div>
                                                </div>
                                                <h3 className="fw-600 font-xss mb-3">
                                                    PhD Information
                                                </h3>
                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Has PhD{" "}
                                                            <span className="text-danger">
                                                                *
                                                            </span>
                                                        </label>
                                                        <select
                                                            name="has_phd"
                                                            className="form-select"
                                                            value={academic.has_phd}
                                                            disabled
                                                        >
                                                            <option value="">
                                                                Select
                                                            </option>
                                                            <option value="1">
                                                                Yes
                                                            </option>
                                                            <option value="0">
                                                                No
                                                            </option>
                                                        </select>
                                                        
                                                    </div>
                                                </div>
                                                <div
                                                    className={
                                                        hasPhd == true
                                                            ? "row"
                                                            : "d-none"
                                                    }
                                                >
                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                PhD From SNU
                                                            </label>
                                                            <select
                                                                name="is_snu_phd"
                                                                className="form-select"
                                                                value={academic.is_snu_phd}
                                                                disabled
                                                            >
                                                                <option value="">
                                                                    Select
                                                                </option>
                                                                <option value="1">
                                                                    Yes
                                                                </option>
                                                                <option value="0">
                                                                    No
                                                                </option>
                                                            </select>
                                                           
                                                        </div>
                                                        </div>
                                                            
                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                PhD Institution
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="phd_institution"
                                                                className="form-control"
                                                                disabled
                                                                value={academic.phd_institution}
                                                            />
                                                           
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                PhD Field
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="phd_field"
                                                                className="form-control"
                                                                value={academic.phd_field}
                                                                disabled
                                                            />
                                                          
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                PhD Topic
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="phd_topic"
                                                                className="form-control"
                                                                value={academic.phd_topic}
                                                                disabled
                                                            />
                                                          
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                PhD Start Year
                                                            </label>
                                                            <input
                                                                type="number"
                                                                name="phd_start_year"
                                                                className="form-control"
                                                                value={academic.phd_start_year}
                                                                disabled
                                                            />
                                                           
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                PhD End Year
                                                            </label>
                                                            <input
                                                                type="number"
                                                                name="phd_end_year"
                                                                className="form-control"
                                                                value={academic?.phd_end_year}
                                                                disabled
                                                            />
                                                            
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                PhD Pursuing
                                                            </label>
                                                            <select
                                                                name="phd_pursuing"
                                                                className="form-select"
                                                                value={academic?.phd_pursuing}
                                                                disabled
                                                            >
                                                                <option value="">
                                                                    Select
                                                                </option>
                                                                <option value="1">
                                                                    Yes
                                                                </option>
                                                                <option value="0">
                                                                    No
                                                                </option>
                                                            </select>
                                                            
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-6 mb-3">
                                                        <div className="form-group">
                                                            <label className="mont-font fw-600 font-xsss">
                                                                PhD Certificate{" "}
                                                                <span className="text-danger">
                                                                    (jpg,png,pdf)
                                                                </span>
                                                            </label>
                                                            <br />
                                                            <a href={academic.phd_certificate} target="_blank" className='btn bg-current text-white'>
                                                                View
                                                            </a>
                                                           
                                                        </div>
                                                    </div>

                                        </div>
                                        </div>
                                        </form>
                                              
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
             {step == 4 && (
                <div
                    className="main-content bg-lightblue theme-dark-bg right-chat-active"
                    style={{ minHeight: "100vh" }}
                >
                    <div className="middle-sidebar-bottom">
                        <div className="middle-sidebar-left">
                            <div className="middle-wrap">
                                <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
                                    <div className="card-body p-4 w-100 bg-current border-0 d-flex rounded-3">
                                        <Link
                                            to="/settings"
                                            className="d-flex align-items-center"
                                        >
                                            <i className="ti-arrow-left font-sm text-white" />
                                        </Link>
                                        <h4 className="font-xs text-white fw-600 ms-4 mb-0 mt-2">
                                            Professional Information
                                        </h4>
                                    </div>
                                    <div className="card-body p-lg-5 p-4 w-100 border-0">
                                        <form onSubmit={handleSubmitProfessional}>
                                            <div className="row">
                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Employability Status <span className="text-danger">*</span>
                                                        </label>
                                                        <select
                                                            name="employability_status"
                                                            className="form-select"
                                                            value={professionalform.employability_status || ""}
                                                            onChange={handleProfessionalChange}
                                                            required
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="employed">Employed</option>
                                                            <option value="unemployed">Unemployed</option>
                                                            <option value="student">Student</option>
                                                            <option value="entrepreneur">Entrepreneur</option>
                                                        </select>
                                                        {(professionalerrors['professionalinfo.employability_status'] || professionalerrors['employability_status']) && (
                                                            <span className="text-danger font-xssss">
                                                                {(professionalerrors['professionalinfo.employability_status'] || professionalerrors['employability_status'])[0]}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label className="mont-font fw-600 font-xsss">
                                                            Work Status <span className="text-danger">*</span>
                                                        </label>
                                                        <select
                                                            name="work_status"
                                                            className="form-select"
                                                            value={professionalform.work_status || ""}
                                                            onChange={handleProfessionalChange}
                                                            required
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="none">None</option>
                                                            <option value="open_to_work">Open to Work</option>
                                                            <option value="hiring">Hiring</option>
                                                        </select>
                                                        {(professionalerrors['professionalinfo.work_status'] || professionalerrors['work_status']) && (
                                                            <span className="text-danger font-xssss">
                                                                {(professionalerrors['professionalinfo.work_status'] || professionalerrors['work_status'])[0]}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="d-flex align-items-center justify-content-between mt-4 mb-3">
                                                <h3 className="fw-700 font-xs mb-0">
                                                    Work Experience
                                                </h3>
                                                <button
                                                    type="button"
                                                    onClick={addRow}
                                                    className="btn bg-current text-white font-xssss fw-600 px-3 py-2 rounded-3 border-0"
                                                >
                                                    + Add Work Experience
                                                </button>
                                            </div>

                                            {professional.length === 0 ? (
                                                <div className="alert alert-light border text-center py-4 text-grey-500 font-xsss rounded-3 mb-4">
                                                    No work experience added yet. Click &quot;+ Add Work Experience&quot; above to add one.
                                                </div>
                                            ) : (
                                                <div className="row">
                                                    {professional.map((row, index) => (
                                                        <div key={index} className="col-12 mb-4">
                                                            <div className="p-3 border rounded-3 bg-greylight position-relative">
                                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                                    <span className="font-xsss fw-700 text-grey-800">
                                                                        Experience #{index + 1}
                                                                    </span>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-outline-danger font-xssss fw-600 px-2 py-1 rounded-2"
                                                                        onClick={() => removeRow(index)}
                                                                    >
                                                                        Remove
                                                                    </button>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-md-6 mb-3">
                                                                        <div className="form-group">
                                                                            <label className="mont-font fw-600 font-xsss">
                                                                                Organisation
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                placeholder="Organisation"
                                                                                className="form-control"
                                                                                value={row.organisation || ""}
                                                                                onChange={(e) => handleProfessionalWorkChange(index, 'organisation', e.target.value)}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6 mb-3">
                                                                        <div className="form-group">
                                                                            <label className="mont-font fw-600 font-xsss">
                                                                                Designation
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                placeholder="Designation"
                                                                                className="form-control"
                                                                                value={row.designation || ""}
                                                                                onChange={(e) => handleProfessionalWorkChange(index, 'designation', e.target.value)}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6 mb-3">
                                                                        <div className="form-group">
                                                                            <label className="mont-font fw-600 font-xsss">
                                                                                Pay Scale
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                placeholder="Pay Scale"
                                                                                className="form-control"
                                                                                value={row.pay_scale || row.payscale || ""}
                                                                                onChange={(e) => handleProfessionalWorkChange(index, 'pay_scale', e.target.value)}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6 mb-3">
                                                                        <div className="form-group">
                                                                            <label className="mont-font fw-600 font-xsss">
                                                                                Start Date
                                                                            </label>
                                                                            <input
                                                                                type="date"
                                                                                className="form-control"
                                                                                value={row.start_date || ""}
                                                                                onChange={(e) => handleProfessionalWorkChange(index, 'start_date', e.target.value)}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6 mb-3">
                                                                        <div className="form-group">
                                                                            <label className="mont-font fw-600 font-xsss">
                                                                                End Date
                                                                            </label>
                                                                            <input
                                                                                type="date"
                                                                                className="form-control"
                                                                                value={row.end_date || ""}
                                                                                disabled={row.is_current == "1" || row.is_current === 1 || row.is_current === true}
                                                                                onChange={(e) => handleProfessionalWorkChange(index, 'end_date', e.target.value)}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6 mb-3">
                                                                        <div className="form-group">
                                                                            <label className="mont-font fw-600 font-xsss">
                                                                                Currently Working Here?
                                                                            </label>
                                                                            <select
                                                                                value={row.is_current ?? ""}
                                                                                className="form-select"
                                                                                onChange={(e) => handleProfessionalWorkChange(index, 'is_current', e.target.value)}
                                                                            >
                                                                                <option value="">Select</option>
                                                                                <option value="1">Yes</option>
                                                                                <option value="0">No</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}

                                            <div className="mt-3">
                                                <button
                                                    type="submit"
                                                    disabled={loader}
                                                    className="btn bg-current text-center text-white font-xsss fw-600 p-3 w-175 rounded-3 d-inline-block border-0"
                                                >
                                                    {loader ? "Saving..." : "Save Changes"}
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
             {step == 0 && (
                <div
                    className="main-content bg-lightblue theme-dark-bg right-chat-active"
                    style={{ minHeight: "100vh" }}
                >
                    <div className="middle-sidebar-bottom">
                        <div className="middle-sidebar-left">
                            <div className="middle-wrap">
                                <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
                                    <div className="card-body p-4 w-100 bg-current border-0 d-flex rounded-3">
                                        <Link to="/settings" className="d-flex align-items-center">
                                            <i className="ti-arrow-left font-sm text-white" />
                                        </Link>
                                        <h4 className="font-xs text-white fw-600 ms-4 mb-0 mt-2">
                                            Page Not Found
                                        </h4>
                                    </div>
                                    <div className="card-body p-lg-5 p-4 w-100 border-0 text-center">
                                     <h1>404 Not Found</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
    </div>
  )
}

export default UpdateProfile